export default "__VITE_ASSET__P28lIHRF__"